import { createAction } from '@reduxjs/toolkit';

import type { Hotel } from 'app/redux/models/Hotel/Hotel';
import type { HotelBrief } from 'app/redux/models/HotelBrief/HotelBrief';
import type { HotelItem } from 'app/redux/models/HotelItem/HotelItem';

export const HOTELS_START_LOADING = 'HOTELS_START_LOADING';
export const HOTELS_STOP_LOADING = 'HOTELS_STOP_LOADING';
export const HOTELS_TRY_FETCH_HOTEL = 'HOTELS_TRY_FETCH_HOTEL';
export const HOTELS_FETCH_HOTEL_SUCCESS = 'HOTELS_FETCH_HOTEL_SUCCESS';
export const HOTELS_TRY_FETCH_HOTELS = 'HOTELS_TRY_FETCH_HOTELS';
export const HOTELS_FETCH_HOTELS_SUCCESS = 'HOTELS_FETCH_HOTELS_SUCCESS';
export const HOTELS_TRY_SAVE_HOTEL = 'HOTELS_TRY_SAVE_HOTEL';
export const HOTELS_TRY_SAVE_BRIEF = 'HOTELS_TRY_SAVE_BRIEF';
export const HOTELS_SAVE_BRIEF_SUCCESS = 'HOTELS_SAVE_BRIEF_SUCCESS';

type tryFetchHotelPayload = {
  hotelId: number;
};

type fetchHotelSuccessPayload = {
  hotel: Hotel;
};

type fetchHotelsSuccessPayload = {
  hotels: HotelItem[];
};

type trySaveHotelPayload = {
  hotel: Hotel;
};

type trySaveBriefPayload = {
  hotelId: number;
  brief: HotelBrief;
};

export const startLoading = createAction(HOTELS_START_LOADING);
export const stopLoading = createAction(HOTELS_STOP_LOADING);
export const tryFetchHotel = createAction<
  tryFetchHotelPayload,
  typeof HOTELS_TRY_FETCH_HOTEL
>(HOTELS_TRY_FETCH_HOTEL);
export const fetchHotelSuccess = createAction<
  fetchHotelSuccessPayload,
  typeof HOTELS_FETCH_HOTEL_SUCCESS
>(HOTELS_FETCH_HOTEL_SUCCESS);
export const tryFetchHotels = createAction(HOTELS_TRY_FETCH_HOTELS);
export const fetchHotelsSuccess = createAction<
  fetchHotelsSuccessPayload,
  typeof HOTELS_FETCH_HOTELS_SUCCESS
>(HOTELS_FETCH_HOTELS_SUCCESS);
export const trySaveHotel = createAction<
  trySaveHotelPayload,
  typeof HOTELS_TRY_SAVE_HOTEL
>(HOTELS_TRY_SAVE_HOTEL);
export const trySaveBrief = createAction<
  trySaveBriefPayload,
  typeof HOTELS_TRY_SAVE_BRIEF
>(HOTELS_TRY_SAVE_BRIEF);
export const saveBriefSuccess = createAction(HOTELS_SAVE_BRIEF_SUCCESS);
